module.exports = __webpack_public_path__ + "static/media/letterMontage.3afbf9a2.png";